var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelRedeemRequesticon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6189 3.17378C15.5186 -0.280086 20.4815 -0.280103 22.3811 3.17378L35.0768 26.257C36.9096 29.5893 34.4988 33.6665 30.6958 33.6665H5.30424C1.50123 33.6665 -0.909583 29.5893 0.923161 26.257L13.6189 3.17378Z",
    fill: "url(#paint0_linear_512_8391)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6666 12C19.6666 11.0795 18.9204 10.3333 17.9999 10.3333C17.0794 10.3333 16.3333 11.0795 16.3333 12V18.6667C16.3333 19.5872 17.0794 20.3333 17.9999 20.3333C18.9204 20.3333 19.6666 19.5872 19.6666 18.6667V12ZM17.9999 27C18.9204 27 19.6666 26.2538 19.6666 25.3333C19.6666 24.4128 18.9204 23.6667 17.9999 23.6667C17.0794 23.6667 16.3333 24.4128 16.3333 25.3333C16.3333 26.2538 17.0794 27 17.9999 27Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_512_8391",
    x1: -1.31171,
    y1: -0.920003,
    x2: 34.695,
    y2: 37.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0833333,
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB834"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelRedeemRequesticon);
export default __webpack_public_path__ + "static/media/CancelRedeemRequesticon.d1016045889312302b4118d21435a4cc.svg";
export { ForwardRef as ReactComponent };